import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cc0894b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-wrap justify-content-center py-2 pl-2 pr-2 border-bottom" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  class: "d-flex align-items-center mb-md-0 me-md-auto text-dark text-decoration-none"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/pifema-logo-dark.svg",
    width: "130"
  }),
  /*#__PURE__*/_createElementVNode("span", {
    class: "fs-4 ml-2",
    style: {"padding-top":"0.2rem"}
  }, " kalkulačka")
], -1))
const _hoisted_3 = { class: "navbar navbar-expand-lg navbar-light" }
const _hoisted_4 = { class: "container-fluid" }
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_6 = { class: "navbar-nav me-auto mb-2 mb-lg-0" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = {
  key: 0,
  class: "d-flex mb-2 pl-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              ($data.store.token != '' && $data.store.user.role.id !== 3)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_PrimevueButton, {
                        label: "Nová obj.",
                        severity: "success",
                        text: "",
                        raised: ""
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("li", _hoisted_8, [
              ($data.store.token != '')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/orders",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_PrimevueButton, {
                        label: "Objednávky",
                        severity: "info",
                        text: "",
                        raised: ""
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("li", _hoisted_9, [
              ($data.store.token != '' && $data.store.user.role.id === 1)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/admin/users",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_PrimevueButton, {
                        label: "Užívatelia",
                        severity: "info",
                        text: "",
                        raised: ""
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("li", _hoisted_10, [
              ($data.store.token == '')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/login",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_PrimevueButton, {
                        label: " Prihlásenie",
                        severity: "info",
                        text: "",
                        raised: ""
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: "javascript:void(0);",
                    class: "nav-link",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.logout()))
                  }, [
                    _createVNode(_component_PrimevueButton, {
                      label: "Odhlásiť sa",
                      plain: "",
                      text: "",
                      raised: "",
                      class: ""
                    })
                  ]))
            ])
          ]),
          ($data.store.token != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_PrimevueButton, {
                  label: $data.store.user.firstName ?? '',
                  severity: "info",
                  text: "",
                  raised: "",
                  class: "font-medium text-base text-800"
                }, null, 8, ["label"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}